import _implicitStylesheets from "./translations.css";

import _implicitScopedStylesheets from "./translations.scoped.css?scoped=true";

import _lightningDatatable from "lightning/datatable";
import _lightningButton from "lightning/button";
import {registerTemplate, sanitizeAttribute} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {t: api_text, h: api_element, b: api_bind, c: api_custom_element, gid: api_scoped_id} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("div", {
    classMap: {
      "translations-tabset__height": true
    },
    key: 0
  }, [api_element("h3", {
    classMap: {
      "translations-lang__align": true
    },
    key: 1
  }, [api_element("span", {
    key: 2
  }, [api_text(" Check languages to migrate ")])]), !$cmp.isexportbtndisabled ? api_element("div", {
    classMap: {
      "translations-menu_align": true
    },
    attrs: {
      "data-my-id": "exportTranslationsButton"
    },
    key: 3,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleExportTranslations))
    }
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-input__icon": true,
      "slds-input__icon_right": true,
      "btn-icon_align": true
    },
    attrs: {
      "title": "Export Translations"
    },
    key: 4
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-icon-text-light": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 5,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#download")
    },
    key: 6,
    svg: true
  }, [])])])]) : null, api_custom_element("lightning-datatable", _lightningDatatable, {
    classMap: {
      "translations-datatable__height": true
    },
    attrs: {
      "data-my-id": "translation-data-table"
    },
    props: {
      "keyField": "id",
      "data": $cmp.data,
      "columns": $cmp.columns,
      "selectedRows": $cmp.preselectedrowsids
    },
    key: 7,
    on: {
      "rowselection": _m1 || ($ctx._m1 = api_bind($cmp.getSelectedTranslation))
    }
  }, [])]), api_element("div", {
    key: 8
  }, [$cmp.isTranslationsSelectedToExport ? api_element("div", {
    key: 9
  }, [api_element("section", {
    classMap: {
      "slds-modal": true,
      "slds-fade-in-open": true
    },
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-05"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-5")
    },
    key: 10
  }, [api_element("div", {
    classMap: {
      "slds-modal__container": true,
      "fitler-modal_div": true,
      "confirm-modal_align": true
    },
    key: 11
  }, [api_element("div", {
    classMap: {
      "slds-modal__content": true,
      "slds-p-around_medium": true
    },
    attrs: {
      "id": api_scoped_id("modal-content-id-5"),
      "data-my-id": "noConfItems"
    },
    key: 12
  }, [api_element("h3", {
    classMap: {
      "conf-modal_align": true
    },
    key: 13
  }, [api_text("No Translations have been selected for Export")]), api_element("br", {
    key: 14
  }, [])]), api_element("footer", {
    classMap: {
      "slds-modal__footer": true,
      "modal-bottom_align": true
    },
    key: 15
  }, [api_custom_element("lightning-button", _lightningButton, {
    props: {
      "label": "OK",
      "variant": "brand",
      "title": "OK"
    },
    key: 16,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.closeExportConfModal))
    }
  }, [])])])]), api_element("div", {
    classMap: {
      "slds-backdrop": true,
      "slds-backdrop_open": true
    },
    key: 17
  }, [])]) : null])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-translations_translations"
